<template>
  <div>
    <div class="main">
      <div><img src="../../../src/assets/errorPageIcon.svg" /></div>
      <div style="margin-top: 27px"><span class="error_text">ERROR</span></div>
      <div style="margin-top: 12px">
        <span class="text">{{ text }}</span>
      </div>
      <div style="margin-top: 47px">
        <el-button style="margin-right: 10px" @click="againlogin"
          >重新登录</el-button
        >
        <el-button style="margin-left: 10px" @click="changeaccount"
          >切换账号</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      text: "当前ip不允许登录投放后台，请联系管理员后重新登录",
    };
  },
  mounted() {
    console.log(this.$route);
    if (this.$route.query.code == "9503") {
      this.text = "当前用户不允许登录投放后台，请联系管理员后重新登录";
    } else if (this.$route.query.code == "9000") {
      this.text = "服务器网络异常，请稍后重试";
    }
  },
  methods: {
    againlogin() {
      this.$store.dispatch("ssologin", {
        cb: (data) => {
          console.log(data);
        },
      });
    },
    changeaccount() {
      let param = { isSwitchAccount: 1 };
      this.$store.dispatch("ssologout", {
        param,
        cb: (data) => {
          console.log(data);
        },
      });
    },
  },
};
</script>
<style  lang="less" rel="stylesheet/less" scoped>
.main {
  max-width: 1140px;
  // margin-right: auto;
  // margin-left: auto;
  padding: 217px 15px 0;
  margin: auto;
  text-align: center;
}
.contain {
  color: #155724;
  // background-color: #d4edda;
  border-color: #c3e6cb;
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.div_flex {
  display: flex;
  justify-content: space-around;
}
.error_text {
  color: #000000;
  opacity: 0.85;
  display: inline-block;
  font-size: 34px;
}
.text {
  color: #000000;
  opacity: 0.65;
  display: inline-block;
  font-size: 18px;
}
</style>